<template>
  <b-popover
    v-if="seatNumber"
    :target="'seat-' + seatNumber"
    variant="ghost"
    triggers="hover"
    placement="top"
  >
    <div class="border-bottom-2 seat-popover">
      <div
        :class="isAvailable && isPremium ? 'text-premium' : 'text-primary'"
      >
        Posto {{ seatNumber }}
      </div>
      <div class="seat-popover-basic-info">
        <span v-if="isSelected">{{ passengerName }}</span
        ><span v-else>{{
          getDisplayAvailability(availability).toUpperCase()
        }}</span
        ><span v-if="price !== 0">{{ formattedPrice }}</span>
      </div>
    </div>
    <div v-if="isPremium" class="seat-characteristics-info">
      <span>{{
        shownCharacteristics
          .map((ch) => userKnowledgeSeatCharacteristics[ch])
          .join(", ")
      }}</span>
    </div>
    <div v-if="isPartiallyAvailable" class="seat-characteristics-info">
      <span
        >Questo posto non è disponibile per tutti i passeggeri indicati</span
      >
    </div>
  </b-popover>
</template>

<script>
import {
  userKnowledgeSeatCharacteristics,
  getDisplayAvailability,
} from '../logic'
import { formatPrice } from '@liveflight/utilities'

export default {
  name: 'SeatPopover',
  props: {
    seatNumber: String,
    isAvailable: {
      type: Boolean,
      default: false,
    },
    isPremium: {
      type: Boolean,
      default: false,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    isPartiallyAvailable: {
      type: Boolean,
      default: false,
    },
    passengerName: {
      type: String,
      default: '',
    },
    availability: {
      type: String,
      default: '',
    },
    price: {
      type: Number,
      default: 0,
    },
    shownCharacteristics: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      userKnowledgeSeatCharacteristics,
    }
  },
  computed: {
    formattedPrice() {
      return this.formatPrice(this.price)
    },
  },
  methods: {
    formatPrice,
    getDisplayAvailability,
  },
}
</script>

<style lang="scss">
.seat-popover {
  min-width: 224px;
}

.seat-popover-basic-info {
  display: flex;
  justify-content: space-between;
  gap: 10%;
}

.text-premium {
  color: $premium-seat-border;
}
</style>
